import React from "react";
import "./TopAnnotation.css";

import { useNavigate } from "react-router-dom";

export interface TopAnnotationConfig {
  userName: string;
  userHandle: string;
  timeAgoDescription: string;
}

export const topAnnotationDemoProps1: TopAnnotationConfig = {
  userName: "John Smith",
  userHandle: "jonny123",
  timeAgoDescription: "2hrs",
};

export function TopAnnotation(props: TopAnnotationConfig): JSX.Element {
  const { userName, userHandle, timeAgoDescription } = props;

  const navigate = useNavigate();
  const navigateToUserProfile = () => navigate(`/@${userHandle}`);

  return (
    <button
      type="button"
      className="standalone-top-annotation"
      onClick={navigateToUserProfile}
    >
      <div className="standalone-top-annotation-username">{userName}</div>
      <div>@{userHandle}</div>
      <div>&nbsp;• {timeAgoDescription}</div>
    </button>
  );
}
